import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV1 } from './baseQueryV1';

export const departmentApi = createApi({
  reducerPath: 'departmentApi',
  baseQuery: baseQueryV1,
  tagTypes: [],
  endpoints: (builder) => ({
    addDepartment: builder.mutation({
      query: (payload) => ({
        url: 'departments',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),

    getDepartments: builder.query({
      query: (params) => ({
        url: 'departments',
        method: 'GET',
        params,
      }),
      transformResponse: (res) => res?.data,
    }),

    updateDepartment: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `departments/${id}`,
        method: 'PUT',
        body: payload,
      }),
      transformResponse: (res) => res?.data,
    }),

    deleteDepartment: builder.mutation({
      query: (id) => ({
        url: `departments/${id}`,
        method: 'DELETE',
      }),
      transformResponse: (res) => res?.data,
    }),
  }),
});

export const {
  useAddDepartmentMutation,
  useGetDepartmentsQuery,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
} = departmentApi;
